import { Breadcrumbs, Link as LinkMui, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

function BaseBreadcrumbs({
  title,
  categoryPath,
  categoryName,
  subCategoryPath,
  subCategoryName,
  subCategoryPath2,
  subCategoryName2,
}: {
  title: string;
  categoryPath?: string;
  categoryName?: string;
  subCategoryPath?: string;
  subCategoryName?: string;
  subCategoryPath2?: string;
  subCategoryName2?: string;
}) {
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "12px" }}>
      <LinkMui underline="hover" color="inherit" component={Link} to="/">
        Home
      </LinkMui>
      {categoryPath && categoryName && (
        <LinkMui underline="hover" color="inherit" component={Link} to={categoryPath}>
          {categoryName}
        </LinkMui>
      )}
      {subCategoryPath && subCategoryName && (
        <LinkMui
          underline="hover"
          color="inherit"
          component={Link}
          to={subCategoryPath}
        >
          {subCategoryName}
        </LinkMui>
      )}
      {subCategoryPath2 && subCategoryName2 && (
        <LinkMui
          underline="hover"
          color="inherit"
          component={Link}
          to={subCategoryPath2}
        >
          {subCategoryName2}
        </LinkMui>
      )}
      <Typography color="text.primary">{title}</Typography>
    </Breadcrumbs>
  );
}

export default BaseBreadcrumbs;
